import { SortDirection } from '@/components/Table/types';
import { usersRepo } from '@/constants/providers';
import { useQuery } from '@tanstack/react-query';
import { UserKey } from './types';

type UseGetAdminsByCompanyProps = {
  companyId: number;
  pageNumber?: number;
  filter?: string;
  sortBy?: string;
  sortOrder?: SortDirection;
};

export const useGetAdminsByCompany = ({
  companyId,
  pageNumber,
  filter,
  sortBy,
  sortOrder,
}: UseGetAdminsByCompanyProps) => {
  return useQuery({
    queryKey: UserKey.COMPANY_ADMIN_USERS_PAGE(companyId, {
      filter,
      pageNumber,
      sortBy,
      sortOrder,
    }),
    queryFn: () =>
      usersRepo.getAdminsByCompany(
        companyId,
        pageNumber,
        filter,
        sortBy,
        sortOrder,
      ),
    cacheTime: 1000 * 60 * 5,
  });
};
